/**
 * Text comparisons for search and duplicate detection (OWA-1342).
 *
 * People type names, emails and search terms in whatever case comes to mind, so
 * these compare without regard to letter case unless the caller asks otherwise.
 */

/**
 * True when two values are the same text, ignoring letter case and surrounding
 * whitespace. Use it for duplicate detection (names, emails). Two missing values
 * are not a match: nothing is not a duplicate of nothing.
 */
export function sameText(a: string | null | undefined, b: string | null | undefined): boolean {
    if (a == null || b == null) return false;
    return a.trim().toLocaleLowerCase() === b.trim().toLocaleLowerCase();
}

/**
 * True when `text` contains `term`. Case-insensitive unless `caseSensitive` is set,
 * matching the search bar's caseSensitive option (off by default).
 */
export function includesText(text: string | null | undefined, term: string | null | undefined, caseSensitive: boolean = false): boolean {
    if (text == null || term == null) return false;
    if (caseSensitive) return text.includes(term);
    return text.toLocaleLowerCase().includes(term.toLocaleLowerCase());
}

/**
 * Keep the first of each value that differs only by letter case or surrounding
 * whitespace. Use with Array.filter, like util.distinctFilter.
 */
export function distinctTextFilter(value: string, index: number, all: string[]): boolean {
    return all.findIndex(v => sameText(v, value)) === index;
}
